import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'

import { MdSearch } from '@react-icons/all-files/md/MdSearch'
import CancelIcon from '@mui/icons-material/Cancel';

import useVibemapSearch from '../utils/search-context/hook'
import VibemapSearchAutoComplete from './AutoComplete'

import { dataStore } from "state/store-zustand";

import './styles/Field.scss'

function VibemapSearchField({
  autoFocus,
  autoComplete,
  initialSearch,
  isPlaceSearch = true,
  key = 'search-field',
  shouldClearForm,
  onFocus,
  onBlur,
  onClear,
  onClick,
  onInputChange,
  onSubmit,
  onUpdate,
  placeholder,
  //secondarySearch,
  showPlaces,
  showEvents,
  showGuides
}) {
  const formRef = useRef()
  const inputRef = useRef()
  const {
    actions,
    searchTerm,
    setSearchTerm,
    secondarySearch
  } = useVibemapSearch()

  const searchValue = useMemo(() => secondarySearch == null ? searchTerm : secondarySearch.value, [secondarySearch, searchTerm])
  console.log('searchValue ', searchValue, searchTerm);
  const [isOpen, setIsOpen] = useState(false)

  const placeToAdd = dataStore((state) => state.placeToAdd)
  const setPlaceToAdd = dataStore((state) => state.setPlaceToAdd)


  useEffect(() => {
    if (autoFocus) {
      inputRef.current.focus()
    }
  }, [inputRef, autoFocus])

  // Set search with initial value
  useEffect(() => {
    if (initialSearch) actions.setSearchTerm(initialSearch)
  }, [initialSearch])

  // Clear search on submit
  useEffect(() => {
    //console.log('TODO: propt to clear form once ', shouldClearForm);
    if (shouldClearForm) actions.setSearchTerm('')
  }, [shouldClearForm])

  const handleSubmit = useCallback((event) => {
    event.preventDefault()
    actions.search()
    onSubmit && onSubmit()
  }, [actions, onSubmit])

  const handleInputChange = useCallback((event) => {
    const searchInput = event.target.value
    console.log('handleInputChange ', searchInput);

    if (onInputChange) onInputChange(searchInput)

    if (secondarySearch == null) {
      actions.setSearchTerm(searchInput)
    } else {
      // If secondary store in object
      console.log(`setSecondarySearch `, { field: secondarySearch.field, value: searchInput });
      actions.setSecondarySearch({ field: secondarySearch.field, value: searchInput })
    }

    if (event.target.value.length > 2) {
      setIsOpen(true)
    }
  }, [actions])


  const handleInputClear = useCallback((event) => {
    event.preventDefault()
    event.stopPropagation()
    actions.setSearchTerm('')
    onClear && onClear()
    setIsOpen(false)
  }, [actions, onClear])

  const handleClick = useCallback((event, data) => {
    onClick(event, data)

    if (isPlaceSearch) setPlaceToAdd(data)

    // Close autocomplete on click
    setIsOpen(false)

  }, [actions])

  const handleUpdate = (data) => {
    if (onUpdate) onUpdate(data)
  }

  useEffect(() => {
    const documentClickHandler = (event) => {
      if (!formRef.current?.contains(event.target)) {
        onBlur?.()
      }
    }
    document.addEventListener('click', documentClickHandler)

    return () => {
      document.removeEventListener('click', documentClickHandler)
    }
  }, [formRef])

  return (
    <form onSubmit={handleSubmit} className='search-field' ref={formRef}>
      <div className={`searchIcon`}>
        <MdSearch
          className='search-field__icon'
          title='Go back'
          size={16}
        />
      </div>
      <input
        id='search_field'
        className='search-field__input'
        onChange={(e) => handleInputChange(e)}
        onFocus={onFocus}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSubmit(e)
          }
        }}
        ref={inputRef}
        placeholder={placeholder}
        key={key}
        type='text'
        value={searchValue ?? ''}
      />
      <div
        className='search-field__clear'
        style={{
          color: '#888',
          display: searchValue ? 'block' : 'none',
          cursor: 'pointer',
          position: 'absolute',
          right: '1rem', top: '0.5rem' }}
        title='Clear search'
        onClick={handleInputClear}>
        <CancelIcon />
      </div>
      <button type='submit' className='button search-field__submit'>
        Search
      </button>
      {autoComplete &&
        <VibemapSearchAutoComplete
          isOpen={isOpen}
          onClick={handleClick}
          onUpdate={handleUpdate}
          showPlaces={showPlaces}
          showEvents={showEvents}
          showGuides={showGuides}
          threshold={0.8} />}
    </form>
  )
}

VibemapSearchField.propTypes = {
  autoComplete: PropTypes.bool,
  autoFocus: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onSubmit: PropTypes.func,
  searchGeocoder: PropTypes.bool,
  searchObjects: PropTypes.string,
  showPlaces: PropTypes.bool,
  showEvents: PropTypes.bool,
  showGuides: PropTypes.bool,
  initialSearch: PropTypes.string,
  shouldClearForm: PropTypes.bool,
  isPlaceSearch: PropTypes.bool,
  key: PropTypes.string,
  onInputChange: PropTypes.func,
  onUpdate: PropTypes.func,
  placeholder: PropTypes.string
}

export default VibemapSearchField